import React, { useEffect } from 'react';
import { useAuth0 } from "@auth0/auth0-react";

//import { assegna_account_google } from './REDUX_feauture/assegna_variabile'
//import { useSelector, useDispatch } from 'react-redux'

const Profile = (props) => {
  const { user, isAuthenticated } = useAuth0();
//  const dispatch = useDispatch()
//  const id_utente1 = useSelector(state => state.variabile.value)


useEffect(() => {
    console.log('---------- USEEFFECT ----------')
    if (isAuthenticated) {
        console.log('---------- isAuthenticated ----------')
    }
}, []);


  return (
    isAuthenticated && ( 
     <div  className="d-flex flex-row justify-content-between" >
      {/* id_utente1 */}
        <div>Ciao {user.name}</div>
        {/* idroslab */}
        <img src={user.picture} alt={user.name}  width="25" height="25"  />
     
        {/* <p>{user.email}</p> */}
        {/* <JSONPretty data={user} /> */}
        {/* {JSON.stringify(user, null, 2)} */}
      </div>
    )
  )
}
export default Profile
